module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.schema.label))]), _vm._v(" "), (_vm.value && _vm.value.length > 1) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "gap": "6px",
      "margin-bottom": "6px"
    }
  }, _vm._l((_vm.value), function(file, fileIndex) {
    return _c('div', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      key: fileIndex,
      staticStyle: {
        "padding": "2px 10px",
        "background-color": "#eee",
        "border-radius": "8px",
        "cursor": "pointer",
        "user-select": "none",
        "border": "solid 1px #ccc"
      },
      on: {
        "click": function($event) {
          _vm.selectedFile = _vm.value[fileIndex]
        }
      }
    }, [_vm._v("\n            " + _vm._s(fileIndex + 1) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.selectedFile) ? _c('div', {
    staticStyle: {
      "padding": "5px",
      "border": "solid 1px #ccc",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0px",
      "top": "-35px"
    }
  }, [(_vm.selectedFile) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', [_c('a', _vm._g({
          staticClass: "transparent",
          attrs: {
            "href": _vm.selectedFile.url,
            "target": "_new"
          }
        }, on), [_c('v-btn', {
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("exit_to_app")])], 1)], 1)])]
      }
    }], null, false, 1716959338)
  }, [_vm._v(" "), _c('span', [_vm._v("Open in New Tab")])]) : _vm._e()], 1), _vm._v(" "), (_vm.hasImage) ? [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.selectedFile.url
    }
  })] : _c('div', [_c('object', {
    staticStyle: {
      "height": "500px",
      "width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "data": _vm.selectedFile.url,
      "type": _vm.selectedFile.type
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.selectedFile.url
    }
  }, [_vm._v("Open " + _vm._s(_vm.schema.label))])])])], 2) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af1c9662"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/viewers/FileView.vue
// module id = 2643
// module chunks = 1